import {
    Button,
    GlanceLoader,
    Tooltip,
    Alert,
  } from '../ui-components';
  import React from 'react';

function SessionLookupState({onCancel, gicon, languageManager}) {

    return (
        <div className='SizeWrapper'>
            <div className='buttonAndTextWrapper'>
                <div className='rowAlign'>
                    { gicon && <div className='Spinner'>
                        <GlanceLoader size="12" spinning={true}></GlanceLoader>
                      </div> }
                   <span className="wrapper no-tooltip-arrow" style={{ display: "inline-block" }}>
                    <Tooltip text={languageManager.getPhrase("integration-stop-request","Stop request")} position="bottom" flip={true} shift={4} offset={4} size="small">
                    <Button size="small" variant="secondary" shape="rounded-full" animation="false" onClick={()=>(typeof(onCancel) === typeof(Function)) ? onCancel() : console.log("Cancel pressed")}>{languageManager.getPhrase("integration-cancel","Cancel")}</Button>
                    </Tooltip>
                    </span>
                </div>
                <div className='AlertWrapper'>
                    <Alert size="small" severity="info" variant="open" heading={languageManager.getPhrase("integration-waiting-for-visitor","Waiting for visitor to connect")} closable="false" /> 
                </div>
            </div>  
        </div>
        
        
    );
}

export default SessionLookupState;